module.exports = __webpack_public_path__ + "static/Icon-Package-48ffd3204ec25bff50941238bad5f1ca.svg";